var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{attrs:{"id":"app"}},[_c('alert-container'),_c('loader-container'),_c(_vm.layout,{tag:"component"},[_c('router-view')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }